export const DS_PAGE_COLUMNS_NATIVE_EVENT = {
  Update: "ds-page-columns:update",
} as const;

export interface DSPageColumnsEmits {
  (event: "update:modelValue", value: number[]): void;
}
